module.exports = __webpack_public_path__ + "static/img/3.4977a04.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/15/eng/3.png
// module id = vnYv
// module chunks = 0